
import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { AlertCircle, CheckCircle, Info, XCircle } from "lucide-react";

interface AlertProps {
  children: ReactNode;
  variant?: 'default' | 'destructive' | 'success' | 'warning' | 'info';
  className?: string;
}

export function Alert({ children, variant = 'default', className }: AlertProps) {
  const getAlertStyles = () => {
    switch (variant) {
      case 'destructive':
        return "bg-red-50 border-red-200 text-red-800";
      case 'success':
        return "bg-green-50 border-green-200 text-green-800";
      case 'warning':
        return "bg-yellow-50 border-yellow-200 text-yellow-800";
      case 'info':
        return "bg-blue-50 border-blue-200 text-blue-800";
      default:
        return "bg-gray-50 border-gray-200 text-gray-800";
    }
  };

  const getIcon = () => {
    switch (variant) {
      case 'destructive':
        return <XCircle className="h-5 w-5 text-red-500" />;
      case 'success':
        return <CheckCircle className="h-5 w-5 text-green-500" />;
      case 'warning':
        return <AlertCircle className="h-5 w-5 text-yellow-500" />;
      case 'info':
        return <Info className="h-5 w-5 text-blue-500" />;
      default:
        return <Info className="h-5 w-5 text-gray-500" />;
    }
  };

  return (
    <div
      className={cn(
        "border p-4 rounded-md",
        getAlertStyles(),
        className
      )}
    >
      {children}
    </div>
  );
}
